module.exports = __webpack_public_path__ + "static/media/TempHRB.a14e43cb.png";